export const BundleAI = () => {
  const routeHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    window.open(
      "https://bundleaistudio.bundle.app/chat/ef07a0b2-7723-4820-bea5-304d394307c5",
      "_blank"
    );
  };

  return (
    <div onClick={routeHandler} id="bundle-ai">
      <div className="bundle-ai-left">
        <img src="./images/bundle-ai.png" alt="bundle-ai" />
        <div className="bundle-ai-left-text-box">
          <div className="bundle-ai-text">
            <span>Bundle</span>
            &nbsp;
            <span
              style={{
                color: "var(--bundle-red)",
              }}
            >
              AI
            </span>
          </div>
          <div className="bundle-ai-line"></div>
          <p className="bundle-ai-subtext">Tarif Sihirbazı’na sor</p>
        </div>
      </div>
      <div className="bundle-ai-right">
        <img src="./images/right-arrow.png" alt="right-arrow" />
      </div>
    </div>
  );
};
